<script lang="ts" setup>
// Placeholder Help / FAQ page — replace with real content.
</script>

<template>
  <div class="help-faq-page">
    <h2>Help / FAQ</h2>
    <p class="muted">
      This page is a placeholder. Content coming soon — in the meantime, use
      Support Tickets for anything you need help with.
    </p>
  </div>
</template>

<style lang="less" scoped>
.help-faq-page {
  padding: 1.5em;

  h2 {
    margin: 0 0 0.5em;
    color: var(--el-color-primary);
  }
  .muted {
    color: var(--el-text-color-secondary);
  }
}
</style>
